import React, { createContext, useState, useContext, useMemo } from 'react'
import { Storage } from './Storage'

const PREVIOUS_APP_STATE_KEY = 'thinkcerca-previous-app-state'

const PreviousAppStateContext = createContext({
  previousAppState: {},
  setPreviousAppState: () => null,
  clearPreviousAppState: () => null,
})

export const usePreviousAppState = () => useContext(PreviousAppStateContext)

export const PreviousAppStateManager = ({ children }) => {
  const [previousAppState, setPreviousAppState] = useState(() => {
    return Storage.fetch(PREVIOUS_APP_STATE_KEY) ?? {}
  })

  const value = useMemo(() => {
    return {
      previousAppState,
      setPreviousAppState: value => {
        setPreviousAppState(value)
        Storage.store(PREVIOUS_APP_STATE_KEY, value)
      },
      clearPreviousAppState: () => {
        setPreviousAppState({})
        Storage.remove(PREVIOUS_APP_STATE_KEY)
      },
    }
  }, [previousAppState, setPreviousAppState])

  return (
    <PreviousAppStateContext.Provider value={value}>
      {children}
    </PreviousAppStateContext.Provider>
  )
}
